import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {BaseEventItemDto} from "../contracts/base-event-item.dto";
import {BaseEventService} from "../services/base-event/base-event.service";
import {Subscription} from "rxjs";

@Injectable()
export class EventsBaseComponent<TEventItem extends BaseEventItemDto> implements OnInit, OnDestroy {
  protected items: TEventItem[] = [];
  protected evService: BaseEventService<TEventItem>;
  private sbs: Subscription;

  constructor(
    private translateService: TranslateService
  ) {
    this.sbs = this.translateService.onLangChange.subscribe(() => {
      this.getEvents();
    });
  }

  ngOnInit() {
    this.getEvents();
  }

  getEvents() {
    this.items = this.evService.getEvents().filter(x => x.private != true);
  }

  ngOnDestroy() {
    if (this.sbs) {
      this.sbs.unsubscribe();
    }
  }
}
